<template>
  <div>
    <div class="priceHistoryChart MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-12" id="priceHistoryChart"></div>
  </div>
</template>
<script>
  import trc from "../data/trc.json"
  export default {
    data() {
      return {
        priceHistoryChart: null,
        workList: trc,
        // 图表数据
        option: {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            show: false,
          },
          calculable: true,
          xAxis: [{
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#858585",
                width: 2,
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: true,
              inside: true,
              lineStyle: {
                width: 2,
                color: '#858585'
              }
            },
            // data: ["28/02/2022", '01/03/2022']
            data: []
          }],
          yAxis: [{
            type: "value",
            nameLocation: 'center',
            nameGap: 100,
            nameTextStyle: {
              // color:"#ffffff",
              // fontSize:16
            },
            scale: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#858585',
                width: 2,
              }
            },
            splitLine: {
              show: true
            }
          }],
          series:[{
            name: 'SOL',
            type: 'line',
            symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbolSize: 8,
            smooth: true,
            lineStyle: {
                normal: {
                    width: 3,
                    color: "rgba(10,219,250,1)", // 线条颜色
                },
                borderColor: 'rgba(0,0,0,.4)',
            },
            itemStyle: {
                color: "rgba(10,219,250,1)",
                borderWidth: 2

            },
            tooltip: {
                show: true
            },
            // data: [80, 100]
            data: []
        }]
        },

      }
    },
    props: ['title'],
    components: {},
    created() {
      this.$nextTick(() => {
        this.initFN();
      });
    },
    mounted() {
      this.getChartData();
    },
    computed: {
      work() {
        let work = this.workList.filter(work => work.title == this.title)[0];
        return work == null ? {} : work;
      },
    },
    watch: {
      title: {
        handler(oldVal, newVal) {
          if(this.work.sold){
            this.option.xAxis[0].data = this.work.priceHistory.date;
            this.option.series[0].data = this.work.priceHistory.data;
            this.chart = this.$echarts.init(document.getElementById("priceHistoryChart"));
          }
        },
      }
    },
    methods: {
      // 初始化
      initFN() {
        var that = this;
        // 渲染图表
        this.chart = this.$echarts.init(document.getElementById("priceHistoryChart"));
        // 填充数据
        this.chart.setOption(this.option, true);
        this.chart.on('click', function(series) {

        })
      },
      // 获取图表数据
      getChartData(){
        if(this.work.sold){
            this.option.xAxis[0].data = this.work.priceHistory.date;
            this.option.series[0].data = this.work.priceHistory.data;
            this.chart = this.$echarts.init(document.getElementById("priceHistoryChart"));
          }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .priceHistoryChart {
    width: 900px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/views/artist/charts/PriceHistoryChart.vue